const badge = {
  baseStyle: () => {
    return {
      fontWeight: 500,
      height: 'fit-content',
    }
  },
  sizes: {},
  variants: {},
  defaultProps: {},
}

export default badge
